import moment from "moment";

const CONSENT_ACCESS_DAYS = 90;

function journeyCreatedMoment(createdAt) {
    const parsed = moment(createdAt);
    return parsed.isValid() ? parsed : moment();
}

function consentAccessUntilDate(createdAt) {
    return journeyCreatedMoment(createdAt).clone().add(CONSENT_ACCESS_DAYS, "days");
}

function formatConsentAccessUntil(createdAt) {
    return consentAccessUntilDate(createdAt).format("DD MMM YYYY");
}

function getDifference (date) {
    const todayDate = moment();
    const pastDate = moment(date);
    const dDiff = pastDate.diff(todayDate);
    if (dDiff > 0) {
        console.log('Date is not past');
    }else{
        console.log('Date is past');
    }
    return dDiff;
}
export {getDifference, CONSENT_ACCESS_DAYS, consentAccessUntilDate, formatConsentAccessUntil};